// src/components/equipements/BadgeFabrication.tsx — SCE Issues
// « En fabrication » (05/10, option A de la maquette
// https://claude.ai/artifact/ArzUFTyfjXggN1i2MPFScR) : une clé et le mot, en
// gris clair — choix de Guillaume. Aucune couleur réservée (rouge critique,
// vert clos, jaune d'interaction) : le repère reste discret dans une liste.

import { Wrench } from 'lucide-react'

export function BadgeFabrication(): JSX.Element {
  return (
    <span
      className="inline-flex items-center whitespace-nowrap"
      style={{
        gap: 5,
        padding: '3px 8px 3px 6px',
        borderRadius: 4,
        backgroundColor: 'var(--color-gray-10)',
        color: 'var(--color-text-primary)',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
      }}
    >
      <Wrench size={13} strokeWidth={2.2} aria-hidden="true" />
      En fabrication
    </span>
  )
}
